(ns app.front.ui.action-bar
  (:require [core.front.carbon :as cc]
            [core.util.util :as util]))

(defn- make-action-button [{:keys [disabled description on-click]
                            :or   {disabled false}}]
  (cc/button (util/mmap {:kind :ghost
                         :size :small}
                        on-click disabled)
             description))

(defn- action-buttons [action-definitions]
  (let [[action-1 & other-actions] (remove nil? action-definitions)]
    (->> other-actions
         (map (fn [action-definition]
                [:div.border-l.border-solid.border-ui-gray
                 [make-action-button action-definition]]))
         (into [:div.flex
                [make-action-button action-1]]))))


(defn action-bar
  "A full-width widget for performing actions"
  [{:keys [actions]} & content]
  (into [:div.rounded.border.border-ui-gray.w-full.border-solid.p-4.flex.flex-wrap.justify-between.items-baseline
         [action-buttons actions]]
        content))
